"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VacationOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M4.7,28.714A3.467,3.467,0,0,1,7,28a3.483,3.483,0,0,1,2.293.707A5.307,5.307,0,0,0,13,30a5.307,5.307,0,0,0,3.7-1.281A3.467,3.467,0,0,1,19,28a3.483,3.483,0,0,1,2.293.707A5.307,5.307,0,0,0,25,30,5.305,5.305,0,0,0,28.708,28.7a.992.992,0,0,0,.006-1.4,1.006,1.006,0,0,0-1.408-.03,3.465,3.465,0,0,1-2.3.719,3.479,3.479,0,0,1-2.293-.707A5.3,5.3,0,0,0,19,26a5.307,5.307,0,0,0-3.7,1.281,3.465,3.465,0,0,1-2.3.719,3.479,3.479,0,0,1-2.293-.707A5.3,5.3,0,0,0,7,26a5.307,5.307,0,0,0-3.707,1.293,1,1,0,0,0-.006,1.4A1.01,1.01,0,0,0,4.7,28.714Z"/><path d="M10,21a2.917,2.917,0,0,0-3,2.829Q7,23.91,7,24a.994.994,0,0,0,.987.993H8a1.006,1.006,0,0,0,1-.981A.919.919,0,0,1,9.816,23,.88.88,0,0,1,10,23H26a1,1,0,0,0,0-2h-9.98l2.32-8.653,8.4,2.25a1.378,1.378,0,0,0,.35.04,1.114,1.114,0,0,0,1.15-.93c.59-4.64-2.46-9.23-7.33-10.98l.02-.04a1,1,0,0,0-1.94-.52l-.01.06a11.754,11.754,0,0,0-2.19-.23,10.363,10.363,0,0,0-9.71,6.04A1.162,1.162,0,0,0,7.8,9.512a1.216,1.216,0,0,0,.143.04l8.47,2.27L13.952,21ZM9.4,7.872a8.523,8.523,0,0,1,7.39-3.88,10.389,10.389,0,0,1,1.67.16c.32.06.64.11.95.19a8,8,0,0,1,.98.33,8.749,8.749,0,0,1,5.92,7.73l-7.45-2-1.94-.51Z"/>';
var VacationOutlineSVG = function VacationOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.VacationOutlineSVG = VacationOutlineSVG;
VacationOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(VacationOutlineSVG);
exports.default = _default;